import { render, staticRenderFns } from "./ProximoPartido.vue?vue&type=template&id=fb9ebd1e&"
import script from "./ProximoPartido.vue?vue&type=script&lang=js&"
export * from "./ProximoPartido.vue?vue&type=script&lang=js&"
import style0 from "./ProximoPartido.vue?vue&type=style&index=0&id=fb9ebd1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports